import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Divider, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { CustomSVG } from 'components';
import { useContent, useCapabilities } from 'hooks';

import { isPinned } from '../../helpers';

const useStyles = makeStyles(theme => ({
  grid: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    cursor: 'pointer',
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
}));

const Pinned: FC = () => {
  const { t } = useTranslation();
  const { isAdmin } = useCapabilities();
  const history = useHistory();
  const classes = useStyles();
  const content = useContent();

  if (!isAdmin || !isPinned(content)) {
    return null;
  }

  const { pinned_end_at } = content;
  const expiresTime = moment.unix(pinned_end_at).format('h:mm A');
  const expiresDate = moment.unix(pinned_end_at).format('MMMM D');

  return (
    <Fragment>
      <Grid
        container
        alignItems="center"
        className={classes.grid}
        onClick={() => history.push(`/post/edit/${content.content_id}`)}
      >
        <CustomSVG name="pin" className={classes.icon} />
        <Typography>{t('content:expiresOn', { expiresTime, expiresDate })}</Typography>
      </Grid>
      <Divider />
    </Fragment>
  );
};

export default Pinned;
